import { useUserComments } from "@/services/hooks";
import { formatSeconds } from "@/utils";
import { formatDate } from "@/utils/time";
import { Verified } from "@mui/icons-material";
import { Avatar, Box, Skeleton, Stack, Typography } from "@mui/material";

export default function UserCommentsContainer({ user }) {
  const { data: comments, isLoading } = useUserComments(user.key);

  if (isLoading) {
    return (
      <>
        <Skeleton
          variant="rectangular"
          height={100}
          sx={{ borderRadius: "10px" }}
        />
        <Skeleton
          variant="rectangular"
          height={100}
          sx={{ borderRadius: "10px" }}
        />
        <Skeleton
          variant="rectangular"
          height={100}
          sx={{ borderRadius: "10px" }}
        />
      </>
    );
  }

  return (
    <Box>
      <Box sx={{ width: "100%" }}>
        {comments?.map((event, index) => (
          <Box key={index} sx={{ mb: 4 }}>
            <Stack
              direction="row"
              spacing={1}
              alignItems="flex-start"
              sx={{ opacity: 0.5 }}
            >
              <Avatar
                src={event.content.owner.meta.profile}
                sx={{ width: 18, height: 18 }}
              />
              <Typography variant="body2">
                {event.content.owner.name}
              </Typography>
              <Typography variant="caption" color="darkgray">
                {event.content.type}
              </Typography>
            </Stack>
            <Typography
              variant="body1"
              sx={{ ml: 3.2, fontSize: "0.8em", opacity: 0.5 }}
            >
              {event.content.meta.text}
            </Typography>
            <Stack
              direction="row"
              alignItems="flex-start"
              spacing={1}
              key={index}
              sx={{ mt: 2, ml: 3.2 }}
            >
              <Avatar
                src={event.user.meta.profile}
                sx={{ width: 24, height: 24 }}
              />

              <Box id="post-content-container" style={{ width: "100%" }}>
                <Box
                  id="post-header"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    marginTop: "-5px",
                  }}
                >
                  <Box
                    id="user-detail"
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      // dont show scrollbar
                      scrollbarWidth: "none",
                      msOverflowStyle: "none",
                      "&::WebkitScrollbar": {
                        display: "none",
                      },
                    }}
                  >
                    <Typography
                      variant="body"
                      style={{ marginRight: "3px", fontWeight: "500" }}
                    >
                      {event.user.name}
                    </Typography>

                    <Typography
                      variant="caption"
                      sx={{ mx: 0.5, color: "lightgray" }}
                    >
                      {formatDate(event.created)}
                    </Typography>

                    {event.data.current_time && (
                      <Typography
                        variant="caption"
                        style={{ margin: "3px 3px 0 3px", color: "lightgray" }}
                      >
                        (at {formatSeconds(event.data.current_time)})
                      </Typography>
                    )}
                  </Box>
                </Box>

                <Box id="post-content" style={{ marginTop: "-5px" }}>
                  <Box
                    style={{ wordWrap: "break-all", whiteSpace: "pre-wrap" }}
                  >
                    <Typography
                      variant="body1"
                      style={{ marginRight: "5px", fontSize: "0.9em" }}
                    >
                      {event.data.text}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Stack>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

function UserBadge({ user, style }) {
  return (
    <>
      {user?.role === "artist" && (
        <Verified
          color={user.verified ? "secondary" : "disabled"}
          style={style}
        />
      )}

      {user?.role === "user" && user?.verified && (
        <Verified color="primary" style={style} />
      )}
    </>
  );
}
